import { classNames } from "../../../../utils/classNames"
import React from "react"
import { useOverflow } from "../../../hooks/useOverflow"

type Props = {
    wrapDivRef: React.RefObject<HTMLDivElement>
}

// Show shadows on the sides, indicating that table is horizontally scrollable
export const ScrollIndicators = (props: Props) => {
    const { refXOverflowing, refXScrollBegin, refXScrollEnd } = useOverflow(props.wrapDivRef)
    const showLeftScrollShadow = refXOverflowing && !refXScrollBegin
    const showRightScrollShadow = refXOverflowing && !refXScrollEnd
    return (
        <>
            <div
                className={classNames(classes.base, classes.left, showLeftScrollShadow ? "opacity-100" : "opacity-0")}
            />
            <div
                className={classNames(classes.base, classes.right, showRightScrollShadow ? "opacity-100" : "opacity-0")}
            />
        </>
    )
}

const classes = {
    base: "pointer-events-none transition-opacity absolute top-0 w-2 h-full from-black/15 to-transparent",
    left: "left-0 bg-gradient-to-r",
    right: "right-0 bg-gradient-to-l",
}
